import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { SharedDataService } from '@services/public_api';

@Component({
  selector: 'app-sharedtekst',
  templateUrl: './sharedtekst.component.html',
  encapsulation: ViewEncapsulation.None
})

export class SharedTekstComponent implements OnInit {
  @Input() key: string;

  tekst$: Observable<string>;

  constructor(
    private _sharedDataService: SharedDataService) { }

  ngOnInit() {
    this.tekst$ = this._sharedDataService.getTekst(this.key);
  }
}
